export const BASEURL = process.env.REACT_APP_BACKEND_API_BASE_URL;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN;
export const NPM_TOKEN = process.env.REACT_APP_NPM_TOKEN;
export const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
